import React from 'react';
import {
  arrayOf, element, elementType, func, node, oneOfType, string
} from 'prop-types';

class Link extends React.Component {
  linkRef = React.createRef();

  // double click to avoid ensighten :eyeroll:
  onLinkClick = () => {
    if (this.linkRef.current) {
      const { onClick } = this.props;
      this.linkRef.current.click();
      if (onClick) {
        onClick();
      }
    }
  };

  render() {
    const {
      children, className, href, usdz
    } = this.props;
    if (!(href || usdz)) {
      return null;
    }
    const assetLink = href || `https://assets.homedepot-static.com/mobile-apps/3d/usdz/${usdz}`;

    return (
      <a
        ref={this.linkRef}
        onTouchStart={this.onLinkClick}
        href={assetLink}
        rel="ar"
        className={className}
      >
        <img src="" alt="" aria-hidden="true" />
        {children}
      </a>
    );
  }
}

Link.propTypes = {
  // Render whatever you want as the link
  children: oneOfType([element, elementType, node, arrayOf(node), string]).isRequired,
  // Add class names to target the ar link
  className: string,
  // href to asset can be provided
  href: string,
  // Callback for when the link is clicked
  onClick: func,
  // usdz name can be provided and component will create the path
  usdz: string
};

Link.defaultProps = {
  className: '',
  href: null,
  onClick: null,
  usdz: null
};

export { Link };
